import axios from 'axios'

class CustomerService {

    //fetches a survey with questions 
    getQuestions = async (SURVEY_ID) => {

        let url = `/api/surveys/${SURVEY_ID}`

        try {
            let resultQuestions = await axios.get(url)

            if (resultQuestions.data.error) throw resultQuestions.data.error

            return resultQuestions.data.data.survey.surveyQuestions;

        }
        catch (error) {
            return Promise.reject(error)
        }
    }


    submitAnswer = async (data, SURVEY_ID) => {
        let url = `/api/surveys/${SURVEY_ID}/customerSurveys/web/anonymous`

        try {
            let result = await axios.patch(url, data)
            if (result.data.error) throw result.data.error

            return result.data

        } catch (error) {
            return Promise.reject(error)
        }

    }
}

export default CustomerService;